export default __webpack_public_path__ + "static/media/close_square_black.563b85a8.svg";